import axios from 'axios'
import { requestInterceptor, responseInterceptor, errorInterceptor } from './persistentAuth'

const httpService = axios.create({
  baseURL: process.env.VUE_APP_ENDPOINT_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

httpService.interceptors.request.use(requestInterceptor)
httpService.interceptors.response.use(responseInterceptor, errorInterceptor)

export default httpService
